export const BRAND = {
  name: "AEROTRON",
  full: "Aerotron Industries",
  logo: "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/6xm78u05_Aerotron%20Industires%20Logo%20Final.jpg",
  tagline: "Precision Engineered. Built to Endure.",
};

export const CONTACT = {
  phones: ["+91 63634 54715", "+91 91138 73947"],
  email: "aerotronindsutries1@gmail.com",
  office: {
    label: "Office",
    lines: [
      "No. 50/2, K No. 988, 2nd Cross,",
      "Patel Ramareddy Layout, Kylasanahalli,",
      "Bengaluru Urban, Karnataka – 560077",
    ],
  },
  factory: {
    label: "Factory",
    lines: [
      "#1/1-3, Narasimhaswamy Complex,",
      "Beside Veeresh Theatre, Magadi Main Road,",
      "Bengaluru Urban, Karnataka – 560079",
    ],
  },
};

export const STATS = [
  { value: "20+", label: "Years Experience" },
  { value: "400+", label: "Moulds Delivered" },
  { value: "150+", label: "Global Clients" },
  { value: "ISO", label: "9001:2015 Certified" },
];

export const MARQUEE = [
  "20+ YEARS EXPERIENCE",
  "400+ MOULDS DELIVERED",
  "150+ GLOBAL CLIENTS",
  "ISO 9001:2015 CERTIFIED",
  "AEROSPACE · AUTOMOTIVE · DEFENSE",
  "PLASTIC · ALUMINIUM · ZINC",
];

export const CAPABILITIES = [
  {
    code: "C01",
    title: "Die-Casting Moulds",
    desc: "High-pressure aluminium & zinc die-casting tools engineered for dimensional stability and long production life.",
  },
  {
    code: "C02",
    title: "Plastic Injection Moulds",
    desc: "Multi-cavity, hot-runner and family moulds for technical polymers with tight tolerance control.",
  },
  {
    code: "C03",
    title: "Jigs & Fixtures",
    desc: "Assembly, welding and inspection fixtures that guarantee repeatability at production scale.",
  },
  {
    code: "C04",
    title: "PCBA / EMS Tooling",
    desc: "Wave-solder pallets, reflow carriers and ICT fixtures for electronic manufacturing lines.",
  },
  {
    code: "C05",
    title: "NPD & Product Development",
    desc: "Concept, CAD, DFM, prototyping and production ramp-up — a single partner from sketch to SOP.",
  },
  {
    code: "C06",
    title: "Production & Assembly",
    desc: "In-house production of plastic and metal parts with full traceability and quality dossiers.",
  },
];

export const PRODUCT_CATEGORIES = [
  {
    id: "plastic-enclosures",
    code: "A",
    title: "Plastic Enclosures",
    tag: "INJECTION // IP-RATED",
    description:
      "AIS-140 telematics, IP67/IP69 field enclosures and technical housings moulded in engineering polymers.",
    items: [
      {
        name: "Plastic Enclosures Portfolio",
        tag: "PLASTIC // IP-RATED",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/ipdu2fn3_PLASTIC.png",
        span: "sm:col-span-2 sm:row-span-2",
      },
      {
        name: "Commercial Automotive Enclosure",
        tag: "PLASTIC // AUTOMOTIVE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/f26ojmva_DC1.png",
      },
    ],
  },
  {
    id: "diecast-parts",
    code: "B",
    title: "Die-Cast Parts",
    tag: "HPDC // ALUMINIUM · ZINC",
    description:
      "High-pressure aluminium and zinc die-cast parts for automotive, power grid, appliance and aerospace applications.",
    items: [
      {
        name: "Aluminium Die-Cast Portfolio",
        tag: "ALUMINIUM // HPDC",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/3yduo7gb_ALUMINIUM.jpg",
        span: "sm:col-span-2 sm:row-span-2",
      },
      {
        name: "Gas Stove Components",
        tag: "DIE-CAST // APPLIANCE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/59idt725_DC2.png",
      },
      {
        name: "Automotive Parts",
        tag: "DIE-CAST // AUTOMOTIVE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/6odp55c5_DC4.png",
      },
      {
        name: "Automotive Component",
        tag: "DIE-CAST // AUTOMOTIVE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/8i3rtsms_DC7.png",
      },
      {
        name: "Structural Die-Cast Bracket",
        tag: "DIE-CAST // STRUCTURAL",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/zgf1z1eg_DC3.png",
      },
      {
        name: "Aerospace Die-Cast Component",
        tag: "DIE-CAST // AEROSPACE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/nz2yrk1p_Diecasting%20Part%201.png",
      },
      {
        name: "Aerospace Backshell Connector",
        tag: "DIE-CAST // AEROSPACE",
        image: "/generated/aerospace_backshell_1.png",
      },
      {
        name: "Aerospace Connector Assembly",
        tag: "DIE-CAST // AEROSPACE",
        image: "/generated/aerospace_backshell_2.png",
      },
      {
        name: "Electrical Terminals",
        tag: "PRECISION // TERMINALS",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/22ox1hij_electric%20terminals%203.png",
      },
      {
        name: "Electrical Terminal Assemblies",
        tag: "PRECISION // TERMINALS",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/kcqq6cqv_electric%20terminals%204.png",
      },
    ],
  },
  {
    id: "diecasting-moulds",
    code: "C",
    title: "Die-Casting Moulds",
    tag: "TOOLROOM // HPDC MOULDS",
    description:
      "Multi-slide aluminium and zinc die-casting moulds engineered for cycle life, dimensional stability and minimal finishing.",
    items: [
      {
        name: "Alu-Zinc Alloy Die-Casting Mould",
        tag: "MOULD // ALU-ZINC",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/h08vyil6_Alu-Zinc-Alloy-Die-casting-mold.jpeg",
        span: "sm:col-span-2 sm:row-span-2",
      },
      {
        name: "Automotive Die-Casting Mould",
        tag: "MOULD // AUTOMOTIVE",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/4lnoscx5_Die-Casting-Mold-2.jpg",
      },
      {
        name: "Open Aluminium HPDC Mould",
        tag: "MOULD // HPDC",
        image: "/generated/diecasting_mould_1.png",
      },
      {
        name: "Multi-Slide Zinc Die Mould",
        tag: "MOULD // ZINC",
        image: "/generated/diecasting_mould_2.png",
      },
      {
        name: "3D CAD — Mould Assembly",
        tag: "CAD // EXPLODED VIEW",
        image: "/generated/diecasting_mould_3d.png",
        span: "sm:col-span-2 sm:row-span-1",
      },
    ],
  },
  {
    id: "ems-tooling",
    code: "D",
    title: "EMS / PCBA Tooling",
    tag: "ELECTRONICS // FIXTURES",
    description:
      "Wave-solder pallets, reflow carriers, ICT fixtures and assembly jigs for high-mix electronic manufacturing lines.",
    items: [
      {
        name: "PCBA Tooling & Fixtures",
        tag: "PCBA // FIXTURES",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/y5v11g01_pcba%20tooling.png",
        span: "sm:col-span-2 sm:row-span-2",
      },
      {
        name: "Wave Solder Pallet",
        tag: "WAVE-SOLDER // PALLET",
        image:
          "https://customer-assets.emergentagent.com/job_aerotron-toolroom/artifacts/dl45hgr0_wave%20solder%20pallet.jpeg",
      },
      {
        name: "PCB In-Circuit Test Jig",
        tag: "ICT // BED-OF-NAILS",
        image: "/generated/pcb_test_jig_1.png",
      },
      {
        name: "Functional Test Fixture",
        tag: "FCT // PNEUMATIC",
        image: "/generated/pcb_test_jig_2.png",
      },
    ],
  },
  {
    id: "conveyor-plastics",
    code: "E",
    title: "Plastic Conveyor Parts",
    tag: "INJECTION // CONVEYOR",
    description:
      "Injection-moulded modular conveyor links, sprockets and chain components in engineering polymers for material-handling lines.",
    items: [
      {
        name: "Modular Conveyor Links",
        tag: "PLASTIC // CONVEYOR",
        image: "/generated/conveyor_plastic_1.png",
        span: "sm:col-span-2 sm:row-span-2",
      },
      {
        name: "Conveyor Chain Modules",
        tag: "PLASTIC // CONVEYOR",
        image: "/generated/conveyor_plastic_2.png",
      },
    ],
  },
];

export const INDUSTRIES = [
  { name: "Automotive", code: "01" },
  { name: "Aerospace", code: "02" },
  { name: "Power Grid", code: "03" },
  { name: "Telecom", code: "04" },
  { name: "EV Mobility", code: "05" },
  { name: "Defense", code: "06" },
];

export const SERVICE_OPTIONS = [
  "Die-Casting Moulds",
  "Plastic Injection Moulds",
  "Jigs & Fixtures",
  "PCBA / EMS Tooling",
  "NPD / Product Development",
  "Production / Assembly",
  "Other",
];
